import type { ReactNode } from 'react';
import React from 'react';

const ButtonGroup = ({ children }: { children: ReactNode }) => {
  return <div className="flex flex-row gap-2">{children}</div>;
};

export default ButtonGroup;
